import { Text } from '@factorialco/deprecated-design-system'
import { SessionFragment } from 'generated/resources/graphql'

import { useSessionsData } from 'modules/trainings/hooks/Sessions/useSessionsData'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

interface Props {
  sessions: SessionFragment[]
}

export const Modality = ({ sessions }: Props) => {
  const { getCombinedModality } = useSessionsData({ sessions })
  const { getModalityTranslation } = useTrainingsDatatable()
  const modality = getCombinedModality()
  if (sessions.length === 0 || !modality) return <Text size="300">-</Text>

  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const translatedModality = getModalityTranslation(modality)

  return <Text size="300">{translatedModality}</Text>
}
